import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconRemove = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 25 24" fill="none">
    <path
      d="M12.5 22.75C6.57 22.75 1.75 17.93 1.75 12C1.75 6.07 6.57 1.25 12.5 1.25C18.43 1.25 23.25 6.07 23.25 12C23.25 17.93 18.43 22.75 12.5 22.75ZM12.5 2.75C7.4 2.75 3.25 6.9 3.25 12C3.25 17.1 7.4 21.25 12.5 21.25C17.6 21.25 21.75 17.1 21.75 12C21.75 6.9 17.6 2.75 12.5 2.75Z"
      fill="currentColor"
    />
    <path
      d="M9.66986 15.58C9.47986 15.58 9.28986 15.51 9.13986 15.36C8.84986 15.07 8.84986 14.59 9.13986 14.3L14.7999 8.64C15.0899 8.35 15.5699 8.35 15.8599 8.64C16.1499 8.93 16.1499 9.41 15.8599 9.7L10.1999 15.36C10.0599 15.51 9.85986 15.58 9.66986 15.58Z"
      fill="currentColor"
    />
    <path
      d="M15.3299 15.58C15.1399 15.58 14.9499 15.51 14.7999 15.36L9.13986 9.7C8.84986 9.41 8.84986 8.93 9.13986 8.64C9.42986 8.35 9.90986 8.35 10.1999 8.64L15.8599 14.3C16.1499 14.59 16.1499 15.07 15.8599 15.36C15.7099 15.51 15.5199 15.58 15.3299 15.58Z"
      fill="currentColor"
    />
  </SvgIcon>
)
